import { ref } from 'vue'

const STORAGE_KEY = 'open_in_focus_mode'

const _enabled = ref(localStorage.getItem(STORAGE_KEY) === '1')

export const openInFocusMode = _enabled

export function setOpenInFocusMode(value: boolean): void {
  _enabled.value = value
  try { localStorage.setItem(STORAGE_KEY, value ? '1' : '0') } catch { /* modo privado etc. */ }
}
